import ResupplyController from "./ResupplyController"
export default ResupplyController

export * from './types.d'
export * from './routes'
export * from './hooks'
export * from './Doctor'